import { BooleanMark } from 'mk2/apps/strollers/components/BooleanMark';
import { Features } from 'mk2/apps/strollers/schemas';
import * as React from 'react';
import styles from './BooleanListFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

export class BooleanListFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features } = this.props;

        const arrValue = feature.booleanPairs(features);

        return (
            <div className={styles.BooleanListFeature}>
                {arrValue.map((booleanPair, idx) => {
                    return (
                        <BooleanMark key={idx} booleanPair={booleanPair} />
                    );
                })}
            </div>
        );
    }
}
